<template>
  <div>
    <list-search-box v-model="form" :is-order-status="true" :is-show-region-business="true" @submit="doSearches" />
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" :row-class-name="tableRowClassName">
        <el-table-column prop="date" label="操作" width="130" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="beforGodIt(row)">
              办理
            </el-button>
            <span v-if="row.showNewContract && row.contractType !== '国际备件下单'" style="margin-left: 10px">
              <el-button type="text" @click="createNewContract(row)">生成新合同</el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="left" fixed="left" min-width="220" />
        <el-table-column prop="contractNum" label="合同编号" align="left" width="140" />
        <el-table-column prop="distributorName" label="代理商名称" align="left" width="200" />
        <el-table-column prop="regionName" label="区域" align="left" width="100" />
        <el-table-column label="现销/赊销" align="left" width="80">
          <template v-slot="{row}">
            <span v-if="row.salesType === 1">现销</span>
            <span v-else-if="row.salesType === 2">赊销</span>
            <span v-else-if="row.salesType === 3">LC</span>
          </template>
        </el-table-column>

        <el-table-column prop="prepaymentRatio" label="预付款比例" align="right" width="100" header-align="left" />

        <el-table-column label="分配比例" align="right" width="70" header-align="left">
          <template v-slot="{row}">
            {{ row.assignRatio }}%
          </template>
        </el-table-column>
        <el-table-column prop="isOrderAutoPassing" label="是否自动化" align="left" width="90">
          <template v-slot="{row}">
            <span>{{ row.isOrderAutoPassing?'是':'否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isOrderAutoPassingSuccess" label="过单状态" align="left" width="90">
          <template v-slot="{row}">
            <span v-if="!row.isOrderAutoPassingSuccess || row.isOrderAutoPassingSuccess === 0">
              <el-button v-if="row.aid" type="text" @click="passingStatus(row.aid,'未过单原因',row.contractType)">未过单</el-button>
              <span v-if="!row.aid">未过单</span>
            </span>
            <span v-if="row.isOrderAutoPassingSuccess === 1 ">成功</span>
            <span v-if="row.isOrderAutoPassingSuccess === 2 ">
              <el-button v-if="row.aid" type="text" @click="passingStatus(row.aid,'失败原因',row.contractType)">失败</el-button>
              <span v-if="!row.aid">失败</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="regionBusinessCommissioner" label="商务" align="left" width="100" />
        <el-table-column prop="finalProcessingTime" label="最后处理时间" align="left" width="160" />
        <el-table-column prop="createTime" label="付款时间" align="left" width="150" />
        <el-table-column prop="contractType" label="订单分类" align="left" width="140" />
        <el-table-column prop="salesManName" label="外销" align="left" width="100" />
        <el-table-column prop="departmentName" label="部门" align="left" width="300" />

        <!--<el-table-column prop="date" label="签章" width="70" align="left">-->
        <!--<template v-slot="{row}">-->
        <!--<el-button type="text">办理</el-button>-->
        <!--</template>-->
        <!--</el-table-column>-->
        <el-table-column fixed="right" prop="date" label="合同附件" width="70" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="showFile(row)">
              操作
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
      <contract-file-dialog ref="fileDialog" />
    </div>
  </div>
</template>
<script type="es6">
import listSearchBox from './listSearchBox';
import contractFileDialog from '../contract/contractFileDialog';
import { getOrdersContractList, createNewContract, checkBlackLock, selectById, intelSelectById } from '@/API';
import { numDiv, MathMulti } from '../../../libs/util';
import { buildCreateContractComplianceRequest, checkExportCompliance, isDomesticContract } from '@/libs/exportCompliance';

export default {
  data () {
    return {
      form: {
        projectName: '',
        contractNum: '',
        contractType: '',
        distributorName: '',
        salesManName: '',
        salesType: '',
        departmentName: '',
        regionName: '',
        tabType: 1,
        createBeginTime: '',
        createEndTime: '',
        startFinalProcessingTime: '',
        endFinalProcessingTime: '',
        startAdvanceCharge: 0,
        endAdvanceCharge: 100,
        startDistributionRatio: 0,
        endDistributionRatio: 100,
        isOrderAutoPassing: '',
        regionBusinessCommissioner: '',
        isInternational: this.isInternationalRoute
      },
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  components: {
    listSearchBox,
    contractFileDialog
  },
  computed: {
    // 国际合同处理页面路由名称为 orderInternationPersionContractList
    isInternationalRoute () {
      return this.$route.name === 'orderInternationPersionContractList';
    }
  },
  methods: {
    doSearch (resolve) {
      this.tableLoading = true;
      getOrdersContractList({
        ...this.form,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        if (resolve) resolve();
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
          this.$emit('totalNumber', this.page.total);
        }
      }).catch(() => {
        if (resolve) resolve();
        this.tableLoading = false;
      });
    },
    doSearches (data, cab) {
      this.page.currentPage = 1;
      this.doSearch();
      cab(false);
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.id, undefined, row.contractType);
    },
    beforGodIt (row) {
      let parmas = { contractNum: row.contractNum };
      checkBlackLock(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.godoIt(row);
        }
      }).catch(() => {

      });
    },
    godoIt (row) {
      if (row.contractType === '国际业务下单' || row.contractType === '国际分销下单' || row.contractType === '国际备件下单' || (row.contractType === '服务订单' && row.civilInternational === 1)) {
        this.$router.push({
          'name': 'orderPersionContractHandlerInternational',
          params: {
            contractNum: row.contractNum,
            contractType: row.contractType
          },
          query: { isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
        });
      } else {
        this.$router.push({
          'name': 'orderPersionContractHandlerDomestic',
          params: {
            contractNum: row.contractNum
          }
        });
      }
    },
    async createNewContract (row) {
      this.tableLoading = true;
      if (isDomesticContract(row)) {
        let request;
        try {
          request = await buildCreateContractComplianceRequest(row);
        } catch (error) {
          this.$message.error(error.message);
          this.tableLoading = false;
          return;
        }
        const decision = await checkExportCompliance(this, request);
        if (!decision.allowBusiness) {
          this.tableLoading = false;
          return;
        }
      }
      createNewContract(row.id).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          if (row.isOrderAdminCreate) {
            if (row.contractType !== '国际业务下单' || row.contractType === '国际分销下单') {
              this.$router.push({
                name: 'orderPersionContractHandledraftsDomestic',
                params: {
                  contractNum: json.data
                }
              });
            } else {
              this.$router.push({
                name: 'orderPersionContractHandledraftsInternational',
                params: {
                  contractNum: json.data
                }
              });
            }
          } else {
            if (row.contractType === '国际业务下单' || row.contractType === '国际分销下单') {
              this.$router.push({
                'name': 'orderPersionContractHandlerInternational',
                params: {
                  contractNum: json.data
                },
                query: { isShowInternationalService: row.civilInternational ? row.civilInternational : '0' }
              });
            } else if (row.contractType === '服务订单') {
              this.$router.push({
                'name': 'orderPersionContractHandlerService',
                params: {
                  contractNum: json.data
                }
              });
            } else {
              this.$router.push({
                'name': 'orderPersionContractHandlerDomestic',
                params: {
                  contractNum: json.data
                }
              });
            }
          }
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    proportion (row) {
      let num = 0;
      if (row.contractSum === 0) {
        num = 0;
      } else {
        num = MathMulti(numDiv(row.assignAll, row.contractSum), 100);
      }
      return Number(num) !== 0 ? Number(num).toFixed(2) : 0;
    },
    tableRowClassName ({ row }) {
      if (row.salesType === 2) {
        return 'warning-row';
      }
      if (row.isHuaQiangFlag === 1) {
        return 'highlight-row';
      }
    },
    passingStatus (id, title, contactType) {
      let parmasId = id;
      if (['国际业务下单', '国际分销下单'].includes(contactType)) {
        intelSelectById({ id: parmasId }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$alert(json.data.reason, title, {
              confirmButtonText: '确定'
            });
          }
        }).catch(() => {});
      } else {
        selectById({ id: parmasId }).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$alert(json.data.reason, title, {
              confirmButtonText: '确定'
            });
          }
        }).catch(() => {

        });
      }
    }
  },
  mounted () {
    this.doSearch();
  }
};
</script>
<style>
  .el-table .warning-row {
    color: red;
  }
  .el-table .highlight-row {
    color: #67C23A;
  }
</style>
